import React, { useEffect, useState } from "react";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../firebase/firebaseConfig";
import "../styles/TeacherDashboard.css";
import EditPeopleForm from "../components/EditPeopleForm";


export default function PeopleSection({ schoolId, clubId }) {
    const [students, setStudents] = useState([]);
    const [teachers, setTeachers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [editingType, setEditingType] = useState(null);


    useEffect(() => {
        const fetchClubData = async () => {
            const clubRef = doc(db, "schools", schoolId, "clubs", clubId);
            const snap = await getDoc(clubRef);
            if (snap.exists()) {
                const data = snap.data();
                setStudents(data.students || []);
                setTeachers(data.teachers || []);
            }
            setLoading(false);
        };

        fetchClubData();
    }, [schoolId, clubId]);

    const saveToFirestore = async (field, updatedArray) => {
        const clubRef = doc(db, "schools", schoolId, "clubs", clubId);
        await updateDoc(clubRef, { [field]: updatedArray });

        if (field === "teachers") setTeachers(updatedArray);
        if (field === "students") setStudents(updatedArray);

        setEditingType(null);
    };


    if (loading) return <p>Loading people...</p>;

    return (
        <div className="people-section">

            {editingType === null && (
                <>
                    <h4>Teachers</h4>
                    <button onClick={() => setEditingType("teacher")} style={{ marginBottom: 10 }}>
                        Edit Teachers
                    </button>
                    <div className="people-grid">
                        {teachers.map((t, i) => (
                            <div key={i} className="person-card">
                                {t.image && <img src={t.image} alt={t.name} className="person-image" />}
                                <p><strong>{t.title || ""} {t.name}</strong></p>
                                <p style={{ fontSize: "0.9em", color: "gray" }}>{t.position}</p>
                            </div>
                        ))}
                    </div>

                    <h4>Students</h4>
                    <button onClick={() => setEditingType("student")} style={{ marginBottom: 10 }}>
                        Edit Students
                    </button>
                    <div className="people-grid">
                        {students.map((s, i) => (
                            <div key={i} className="person-card">
                                {s.image && <img src={s.image} alt={s.name} className="person-image" />}
                                <p><strong>{s.name}</strong></p>
                            </div>
                        ))}
                    </div>
                </>
            )}

            {editingType === "teacher" && (
                <EditPeopleForm
                    people={teachers}
                    type="teacher"
                    onSave={(updated) => saveToFirestore("teachers", updated)}
                    onCancel={() => setEditingType(null)}
                />
            )}

            {editingType === "student" && (
                <EditPeopleForm
                    people={students}
                    type="student"
                    onSave={(updated) => saveToFirestore("students", updated)}
                    onCancel={() => setEditingType(null)}
                />
            )}
        </div>
    );

}